const NON_NEGATIVE_INTEGER_PATTERN = /^\d+$/;

export const isValidScoreValue = (value) => {
  if (!NON_NEGATIVE_INTEGER_PATTERN.test(String(value))) {
    return false;
  }

  return Number.isSafeInteger(Number(value));
};

export const isValidScoreInput = (value) => value === "" || isValidScoreValue(value);

export const parseScoreCsv = (scoresCsv) => {
  if (!scoresCsv) {
    return [];
  }

  return scoresCsv.split(",").map((set) => {
    const match = /^(\d+)-(\d+)$/.exec(set.trim());

    return match ? [match[1], match[2]] : ["", ""];
  });
};

export const isValidScoreGrid = (scores) =>
  Array.isArray(scores) &&
  scores.length > 0 &&
  scores.every(
    (set) => Array.isArray(set) && set.length === 2 && set.every((score) => isValidScoreValue(score)),
  );

export const serializeScoreGrid = (scores) => {
  if (!isValidScoreGrid(scores)) {
    return null;
  }

  return scores.map((set) => set.map((score) => Number(score)).join("-")).join(",");
};

export const winnerFromScores = (scores, participantIds) => {
  let playerOneSets = 0;
  let playerTwoSets = 0;

  scores.forEach((set) => {
    if (!set.every((score) => isValidScoreValue(score))) {
      return;
    }

    const [playerOneScore, playerTwoScore] = set.map(Number);
    if (playerOneScore > playerTwoScore) playerOneSets++;
    if (playerOneScore < playerTwoScore) playerTwoSets++;
  });

  if (playerOneSets > playerTwoSets) return participantIds[0];
  if (playerOneSets < playerTwoSets) return participantIds[1];

  return -1;
};
